var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.143,
    viewBox: "0 0 20 17.143",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "up-to-line",
    d: "M.714,33.429H16.429a.714.714,0,1,0,0-1.429H.714a.714.714,0,1,0,0,1.429ZM8.491,37.75a.112.112,0,0,1,.08-.036.1.1,0,0,1,.08.036l5.554,5.888a.29.29,0,0,1,.08.205.3.3,0,0,1-.3.3H11.429a.716.716,0,0,0-.714.714v5.357a.358.358,0,0,1-.357.357H6.786a.358.358,0,0,1-.357-.357V44.857a.716.716,0,0,0-.714-.714H3.156a.3.3,0,0,1-.3-.3.32.32,0,0,1,.08-.205Zm.08-1.464a1.54,1.54,0,0,0-1.121.482L1.9,42.661a1.728,1.728,0,0,0,1.259,2.911H5v4.643A1.785,1.785,0,0,0,6.786,52h3.571a1.785,1.785,0,0,0,1.786-1.786V45.571h1.844a1.728,1.728,0,0,0,1.259-2.911L9.692,36.768A1.54,1.54,0,0,0,8.571,36.286Z",
    transform: "translate(52) rotate(90)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expand-arrow.abfa0f443a319d0f57aaa586f927f198.svg";